<script>
import { BIcon } from 'bootstrap-vue'
import { services } from '@utils/common-services'
// import {BaseLink} from '@src/components/_base-link.vue'
// import route from '../../router/views/user/route'
// Allows stubbing BaseLink in unit tests
// const BaseLink = 'BaseLink'

export default {
  // Functional components are stateless, meaning they can't
  // have data, computed properties, etc and they have no
  // `this` context.
  ///  functional: true,
  // components:{BaseLink},
  components: {
    BIcon,
  },
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      windowWidths: window.screen.width,
      name: 'grid',
      isStaff: false,
    }
  },
  beforeMount() {
    this.getApplicant()
  },
  beforeDestroy() {
    var doc = this.$refs.navbarroutes
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    getApplicant() {
      var user = services.decodeJWT(services.getAuth())
      this.isStaff = user.is_staff
    },
    getRouteTitle(route) {
      return typeof route.title === 'function' ? route.title() : route.title
    },
    getRouteClass(route) {
      return route.class
    },
    callAlert() {
      // var myclass = this.getElementById("hamberg")
      // myclass.classList.add("mystyle");
      // console.log('Class name = '+ myclass)
      // myclass.classList.add("testClass")
      // console.log('clicked')
      if (this.windowWidths < 767) {
        //  this.setMenubar({ newVal: false })
        this.$root.$emit('changeMenu', {
          data: false,
        })
        //   this.$emit('menu',{data:false})
        //         console.log('changes'+ false)
      }
    },
  },
  // Render functions are an alternative to templates
}
</script>
<template>
  <div ref="navbarroutes">
    <li v-for="(route, index) in routes" :key="index" :class="$style.active">
      <RouterLink
        v-if="
          route.subMenu !== undefined
            ? route.subMenu.length < 0
              ? true
              : false
            : true
        "
        id="menuLinks"
        :class="[$style.menuIcon, getRouteClass(route)]"
        class="menuLink"
        :to="{ name: route.route }"
        :exact="isStaff ? false : true"
      >
        <h3
          :class="$style.menuItemsClicks"
          :data-menu="getRouteTitle(route)"
          @click="callAlert"
        >
          <BIcon
            class="mr5 appLeftIcon"
            :class="$style.appLeftIcon"
            :icon="route.icon"
          ></BIcon>
          {{ getRouteTitle(route) }}
        </h3>
        <!-- </h6> -->
      </RouterLink>
      <a
        v-else
        id="menuLinks"
        v-b-toggle="'collapse' + index"
        :class="[$style.menuIcon, getRouteClass(route)]"
        class="menuLink"
        ><h3 :class="$style.menuItemsClicks" :data-menu="getRouteTitle(route)"
          ><BIcon
            class="mr5 appLeftIcon"
            :class="$style.appLeftIcon"
            :icon="route.icon"
          ></BIcon>
          {{ getRouteTitle(route) }}</h3
        ></a
      >
      <b-collapse
        v-if="
          route.subMenu !== undefined
            ? route.subMenu.length > 0
              ? true
              : false
            : false
        "
        :id="'collapse' + index"
      >
        <ul :class="$style.subMenu">
          <CommonBaseNavBarRoutes :routes="route.subMenu" />
        </ul>
      </b-collapse>
    </li>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.menuIcon {
  position: relative;
  text-decoration: none !important;
}

.subMenu {
  .menuItemsClicks {
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 12px;
    border-bottom: 1px solid #fff7f4 !important;

    .subMenuIcon {
      top: 0 !important;
      font-size: 12px !important;
    }

    svg {
      font-size: 13px !important;
    }
  }
  &:hover {
    background: #fffaf8 !important;
  }
}

@media (max-width: 767px) {
  .subMenu {
    .menuItemsClicks {
      padding: 16px 10px 16px 45px !important;
    }
  }
}
</style>
